











































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Files from './Files.vue';
import Status from './Status.vue';
import WarningsComponent from './Warnings.vue';
import { ValidationResult } from './types';
import { prepareData, validateData, commitData, filterNonEmptyWarnings } from './utils';
import DialogPage from './DialogPage.vue';

/**
 * There are 4 stages of uploading:
 *  1. select files
 *  2. process files on clientside, send to server and validate data
 *  3. show warnings
 *  4. commit data
 *  5. error
 */

@Component({
    components: {
        DialogPage,
        Files,
        Status,
        Warnings: WarningsComponent,
    }
})
export default class Uploader extends Vue {
    public stage: number = 1;
    public validationResult?: ValidationResult;

    public setStage2(files: File[]) {
        this.stage = 2;

        prepareData(files)
        .then(data => validateData(data))
        .then(validationResult => this.setStage3(validationResult))
        .catch((error) => this.setErrorStage(error));
    }

    public setStage3(validationResult: ValidationResult) {
        if (filterNonEmptyWarnings(validationResult.response.warnings).length === 0) {
            this.setStage4(validationResult);
        } else {
            this.stage = 3;
            this.validationResult = validationResult;
        }
    }

    public setStage4(validationResult: ValidationResult) {
        this.stage = 4;

        commitData(validationResult)
            .then(() => this.$emit('close'))
            .catch((error) => this.setErrorStage(error));
    }

    public setErrorStage(error: any) {
        this.stage = 5;
        throw (error);
    }
}
